import BotChat from "../botChat";
import {FeedbackRating, FeedbackReason} from "../../types/enums";
import {MessageFactory} from "../factory/messageFactory";
import {ClientErrorLogger} from "../utils/clientErrorLogger";
import {FeedbackRatingMessage, FeedbackReasonMessage} from "../../types/chat";
import {trySendMessage} from "../utils/socketUtils";

export class ChatFeedbackHandler {

    constructor(
        private readonly chat: BotChat,
        private readonly trademark: string,
    ) { }

    public async sendFeedbackRating(id: string, messageId: string, rating: FeedbackRating, client: string): Promise<void> {
        await this.sendFeedback(id, messageId, rating, client);
    }

    public async sendFeedbackReason(id: string, messageId: string, reasonCode: FeedbackReason, client: string, freeText: string|null = null): Promise<void> {
        await this.sendFeedback(id, messageId, null, client, reasonCode, freeText);
    }

    public async sendFeedback(
        id: string,
        messageId: string,
        rating: FeedbackRating|null,
        client: string,
        reasonCode: FeedbackReason|null = null,
        freeText: string|null = null,
    ): Promise<void> {
        let webSocket = await this.chat.getChatConnector().getWebSocket();
        if (webSocket === null) {
            return;
        }

        // UserData ist erst nach der websocket-initialisierung verfügbar
        let userData = this.chat.getChatConnector().getUserData();
        if (userData === null) {
            (new ClientErrorLogger()).logInfo('userData not found for message Id '+ messageId);
            return;
        }

        let message = null;
        if(rating !== null) {
            message = MessageFactory.createFeedbackRatingMessage(
                id,
                messageId,
                rating,
                this.trademark,
                client,
                userData.getSubscriberId(),
                userData.getBotChatSessionId(),
                userData.getUserChatSessionId()
            )
        } else {
            message = MessageFactory.createFeedbackReasonMessage(
                id,
                messageId,
                reasonCode,
                freeText,
                this.trademark,
                client,
                userData.getSubscriberId(),
                userData.getBotChatSessionId(),
                userData.getUserChatSessionId()
            );
        }

        await trySendMessage(
            webSocket,
            message,
            (ws: WebSocket|undefined = undefined) => this.handleSendFeedbackError(ws),
            this,
            this.chat.getChatConnector()
        );
    }

    public handleSendMessage = (
        chatWebSocket: WebSocket|null,
        message: FeedbackRatingMessage|FeedbackReasonMessage,
        onError: () => void
    ): void =>
    {
        if (chatWebSocket === null) {
            onError();
            return;
        }

        chatWebSocket.send(JSON.stringify(message));
    }

    public handleSendFeedbackError= (webSocket: WebSocket|undefined = undefined): void =>
    {
        this.chat.handleWebsocketError('send Feedback error', {
            messageType: 'SendFeedback',
            reason: 'Timeout oder keine Antwort',
            websocket: webSocket
        });
    }
}

